
import { Component, Vue } from "vue-property-decorator";
import { dataVisualizationModule } from "@/store";

@Component
export default class TherapyInstrument extends Vue {

  headerTranslations: Record<string, string> = {
    DataFieldIdentifier: "Kennung",
    Value: "Wert",
    PatientCount: "Patientenanzahl",
    PatientPercentage: "Prozentsatz der Patienten"
  };

  // Use new getter with key-based data
  get chartData(): any[] {
    return dataVisualizationModule.getChartData("therapyInstrument");
  }

  get tableHeaders(): string[] {
    return this.chartData.length ? Object.keys(this.chartData[0]) : [];
  }

  async mounted() {
    try {
      await dataVisualizationModule.loadAll("therapyInstrument");
    } catch (e) {
      console.error("Failed to load chart data:", e);
    }
  }
}
